import { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router";
import VideoBox from "../../casinoComponents/videoBox";
import BetTableKBC from "../../casinoComponents/betTableKBC";
import CasinoHeading from "../../casinoComponents/casinoHeading";
import CasinoLastResult from "../../casinoComponents/casinoLastResult";
import CasinoTableLayout from "../../casinoComponents/casinoTableLayout";
import MyBet from "../../casinoComponents/myBet";
import ViewMoreModal from "../../../components/ViewMoreModal";
import KbcCardsOverlay from "../../casinoComponents/videoBox/overlays/KbcCardsOverlay";
import KbcResults from "./KbcResults";
import { getCasinoGameDetails, getMatchExposure, getMyBets } from "../../../apiservices/CasionApi";
import { extractCasinoGame } from "../../../utils/casinoGame";
import "../../../styles/games/kbc.css";

// Reference game header title (casino/lastresults2 res1.cname)
const TITLE = "K.B.C";

export default function Kbc() {
  const [gameData, setGameData] = useState(null);
  const [exposures, setExposures] = useState({});
  const [myBets, setMyBets] = useState([]);
  const [showViewMoreModal, setShowViewMoreModal] = useState(false);
  const { pathname } = useLocation();
  const gameName = extractCasinoGame(pathname) || "kbc";
  const iframeSrc = `https://stream-s-43.uhdmovies.online/casino-stream?id=${gameName}`;

  useEffect(() => {
    const name = extractCasinoGame(pathname) || "kbc";
    const fetchGameData = async () => {
      try {
        const resp = await getCasinoGameDetails(name);
        setGameData(resp);
      } catch (err) {
        console.error("Error fetching KBC game data:", err);
      }
    };
    fetchGameData();
    const timer = setInterval(fetchGameData, 1500);
    return () => clearInterval(timer);
  }, [pathname]);

  const matchId =
    gameData?.data?.data?.mid?.toString() ||
    gameData?.data?.mid?.toString() ||
    gameData?.mid?.toString();

  const fetchExposure = useCallback(async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      const userId = user?.user_id || user?.id || user?.staff_id || user?.owner_id;
      if (userId && matchId) {
        const response = await getMatchExposure(userId, matchId);
        if (response.success && response.data) {
          const exposureMap = {};
          response.data.forEach((item) => {
            exposureMap[item.team_name] = parseFloat(item.exposure_amount) || 0;
          });
          setExposures(exposureMap);
        }
      }
    } catch (error) {
      console.error("Error fetching exposure:", error);
    }
  }, [matchId]);

  const fetchMyBetsData = useCallback(async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      const userId = user?.user_id || user?.id || user?.staff_id || user?.owner_id;
      if (userId && matchId) {
        const response = await getMyBets(userId, matchId);
        if (response.success && response.bets) {
          const formattedBets = response.bets.map((bet) => ({
            // My Bets "Gametype" column (casino_bets.game_name, e.g. mogambo)
            description: bet.description ?? bet.game_name ?? bet.gameName,
            userName: bet.userName ?? bet.username,
            placeDate: bet.placeDate ?? bet.created_at,
            matchedBet: bet.player_name || bet.selection || "",
            odds: bet.odds || "0",
            stake: bet.stake || "0",
            type: bet.type || null,
            selection: bet.selection || bet.player_name || "",
            teamName: bet.player_name || bet.selection || "",
          }));
          setMyBets(formattedBets);
        }
      }
    } catch (error) {
      console.error("Error fetching my bets:", error);
    }
  }, [matchId]);

  useEffect(() => {
    if (matchId) {
      const refresh = () => {
        fetchExposure();
        fetchMyBetsData();
      };
      const t = setTimeout(refresh, 0);
      const exposureInterval = setInterval(refresh, 2000);
      return () => {
        clearTimeout(t);
        clearInterval(exposureInterval);
      };
    }
  }, [matchId, fetchExposure, fetchMyBetsData]);

  // Admin cannot place bets: a click only refreshes exposure / My Bets (like the other casino pages)
  const handleBetClick = () => {
    fetchExposure();
    fetchMyBetsData();
  };

  const d = gameData?.data?.data;
  const roundId = d?.mid || "";

  return (
    <CasinoTableLayout
      tableClass="kbc"
      rightSide={<MyBet bets={myBets} onViewMore={() => setShowViewMoreModal(true)} />}
    >
      <>
        <CasinoHeading name={TITLE} roundId={roundId} />
        <VideoBox
          gameType={gameName}
          resultData={d?.card}
          iframeSrc={iframeSrc}
          timerValue={d?.lt}
          cardsOverlay={<KbcCardsOverlay card={d?.card} />}
        />
        {d?.mid ? (
          <div className="casino-detail">
            <BetTableKBC data={d?.sub || []} onBetClick={handleBetClick} exposures={exposures} />{" "}
            {d?.remark ? (
              <div className="casino-remark mt-1 w-100">
                <div className="remark-icon">
                  <img src={`${import.meta.env.BASE_URL}assets/img/icons/remark.png`} alt="" />
                </div>{" "}
                <marquee>{d.remark}</marquee>
              </div>
            ) : null}{" "}
            <CasinoLastResult
              gameType={gameName}
              resultComponent={<KbcResults gameType={gameName} fallbackTitle={TITLE} />}
            />
          </div>
        ) : null}
      </>
      <ViewMoreModal
        show={showViewMoreModal}
        onHide={() => setShowViewMoreModal(false)}
        title="View More"
        sectionKey={gameName}
      />
    </CasinoTableLayout>
  );
}
